import { MessageMetadata } from './MessageMetadata.tsx';
import type { MetadataConfig } from './CustomStepCreator.types.ts';
import { DocumentUploadMetadata } from './DocumentUploadMetadata.tsx';
import { DischargeLetterUploadMetadata } from './DischargeLetterUploadMetadata.tsx';

export const metadataConfig: MetadataConfig = {
  DOCUMENT_UPLOAD: {
    initialValue: { documentType: 'IDENTIFICATION' },
    component: DocumentUploadMetadata,
  },
  MESSAGE: {
    initialValue: { messageContext: 'nurse' },
    component: MessageMetadata,
  },
  DISCHARGE_LETTER_UPLOAD: {
    initialValue: {},
    component: DischargeLetterUploadMetadata,
  },
};
